var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_empty_cart_co35",
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 171.995,
    viewBox: "0 0 206 171.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_empty_cart_co35-2",
    "data-name": "undraw_empty_cart_co35",
    transform: "translate(0)",
    opacity: 0.445
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M187.657,749.844c2.857,5.3,8.922,7.574,8.922,7.574s1.432-6.317-1.426-11.616-8.922-7.574-8.922-7.574S184.8,744.545,187.657,749.844Z",
    transform: "translate(-178.085 -585.978)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M163.536,773.892c5.159,3.1,7.146,9.269,7.146,9.269s-6.377,1.133-11.536-1.971S152,771.921,152,771.921,158.377,770.788,163.536,773.892Z",
    transform: "translate(-152 -611.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 32.188,
    height: 0.46,
    transform: "translate(95.01 8.256)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 0.46,
    height: 4.253,
    transform: "translate(118.001 8.6)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 0.46,
    height: 4.253,
    transform: "translate(103.977 8.6)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 32.188,
    height: 0.46,
    transform: "translate(111.334 30.327)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 0.46,
    height: 4.253,
    transform: "translate(120.071 26.189)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 0.46,
    height: 4.253,
    transform: "translate(134.095 26.189)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 32.188,
    height: 0.46,
    transform: "translate(154.097 40.673)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 0.46,
    height: 4.253,
    transform: "translate(162.834 36.535)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 0.46,
    height: 4.253,
    transform: "translate(176.858 36.535)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 32.188,
    height: 0.46,
    transform: "translate(150.879 147.352)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 0.46,
    height: 4.253,
    transform: "translate(159.615 143.213)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 0.46,
    height: 4.253,
    transform: "translate(173.64 143.213)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 32.188,
    height: 0.46,
    transform: "translate(95.93 73.55)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 0.46,
    height: 4.253,
    transform: "translate(104.667 69.412)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 0.46,
    height: 4.253,
    transform: "translate(118.691 69.412)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 32.188,
    height: 0.46,
    transform: "translate(106.046 128.959)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 0.46,
    height: 4.253,
    transform: "translate(114.783 124.82)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 0.46,
    height: 4.253,
    transform: "translate(128.807 124.82)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 32.188,
    height: 0.46,
    transform: "translate(157.546 112.175)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 0.46,
    height: 4.253,
    transform: "translate(166.283 108.037)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 0.46,
    height: 4.253,
    transform: "translate(180.307 108.037)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M179.714,619.91h-54.44v-.392h54.048v-19H129.851l-2.4-5.007.353-.169,2.3,4.784h49.617Z",
    transform: "translate(-96.472 -458.47)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 4.112,
    cy: 4.112,
    r: 4.112,
    transform: "translate(31.935 162.81)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 4.112,
    cy: 4.112,
    r: 4.112,
    transform: "translate(72.471 162.81)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 2.546,
    cy: 2.546,
    r: 2.546,
    transform: "translate(121.819 77.039)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M290.079,520.809h-61.19l-13.24-43.278h88.066l-.08.255Zm-60.9-.392h60.613l13.389-42.494h-87Z",
    transform: "translate(-201.015 -385.218)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M147.635,451.4H93.889L82.26,413.015h77.351l-.07.226Z",
    transform: "translate(-63.348 -318.058)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M450.2,351.736l-.379-.1,2.584-9.741h15.034v.392H452.7Z",
    transform: "translate(-346.4 -263.289)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 79.387,
    height: 0.392,
    transform: "translate(18.912 105.433)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 70.426,
    height: 0.392,
    transform: "translate(23.326 119.863)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 0.392,
    height: 42.886,
    transform: "translate(58.469 92.509)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 42.977,
    height: 0.392,
    transform: "matrix(0.065, -0.998, 0.998, 0.065, 73.585, 135.382)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 0.392,
    height: 42.977,
    transform: "translate(40.552 92.521) rotate(-3.729)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 206,
    height: 1,
    transform: "translate(0 170.995)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M747.411,135.7s3.361,9.566,1.293,11.037,6.98,13.49,6.98,13.49l10.858-2.943L760.6,147.227s-.776-10.056-.776-11.528S747.411,135.7,747.411,135.7Z",
    transform: "translate(-610.519 -121.474)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M747.411,135.7s3.361,9.566,1.293,11.037,6.98,13.49,6.98,13.49l10.858-2.943L760.6,147.227s-.776-10.056-.776-11.528S747.411,135.7,747.411,135.7Z",
    transform: "translate(-610.519 -121.474)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M721.413,410.235s-.981,12.264,0,18.641,2.453,24.037,2.453,24.037,0,33.357,5.4,33.848,9.32.981,9.811-.981-2.453-2.943-.981-3.924,1.962-4.415,0-8.339,0-43.659,0-43.659l9.32,25.018s.981,20.6,1.962,23.546-.981,8.339,2.453,8.83,7.358-2.453,9.32-3.434-2.943-.981-1.962-1.472,3.924-1.962,2.943-2.453-1.962-24.037-1.962-24.037-2.7-50.281-6.132-52.244-5.641,1.418-5.641,1.418Z",
    transform: "translate(-590.163 -327.822)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M754.707,758.784v3.924s-4.415,10.668,0,10.668,7.849,1.105,7.849-.366V759.765Z",
    transform: "translate(-614.627 -601.808)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M860.875,758.754v3.924s4.415,10.668,0,10.668-7.849,1.105-7.849-.366V759.735Z",
    transform: "translate(-691.853 -601.785)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 8.83,
    cy: 8.83,
    r: 8.83,
    transform: "translate(134.929 3.679)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M762.26,201.9s2.453,7.358,6.377,5.887l3.924-1.472,6.868,47.093s-5.4,7.849-13.245,2.943S762.26,201.9,762.26,201.9Z",
    transform: "translate(-621.2 -172.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M795.418,179.889l2.207-4.66s13,6.132,14.962,8.094a7.661,7.661,0,0,1,1.962,4.906l-3.434,12.264s.981,26.98.981,27.961,3.434,6.377.981,4.415-2.943-3.924-4.906-.981-6.377,6.377-6.377,6.377Z",
    transform: "translate(-647.489 -152.419)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M841.21,349.122l-1.472,13.735s-8.83,7.849-6.868,8.339a2.715,2.715,0,0,0,2.943-1.472s3.434,3.434,5.4,1.472,6.868-20.6,6.868-20.6Z",
    transform: "translate(-676.112 -286.332)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M743.787,76.044c-1.957-.07-4.052-.1-5.7.95a8.35,8.35,0,0,0-1.971,1.929c-1.607,2.032-3,4.589-2.4,7.11l.693-.27a4.541,4.541,0,0,1-.438,1.946c.1-.284.425.175.337.462l-.764,2.506a2.36,2.36,0,0,1,3.009,1.8c.087-2.911.389-6.249,2.751-7.953a9.514,9.514,0,0,1,4.148-1.355,8.344,8.344,0,0,1,4.021.02,2.893,2.893,0,0,1,2.082,3.074,1.369,1.369,0,0,1,1.544.761,4,4,0,0,1,.316,1.829c.63.445,1.346-.439,1.6-1.166a10.525,10.525,0,0,0,.813-5.3c-.325-1.781-1.776-3.483-3.586-3.489a1.257,1.257,0,0,0,.327-.885l-1.492-.126a1.649,1.649,0,0,0,.985-.519C749.466,78.018,744.756,76.079,743.787,76.044Z",
    transform: "translate(-599.84 -76.014)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M708.8,176.758s-3.993-3.913-5.431-3.674-3.4,3.674-3.4,3.674-11.773,3.924-11.283,7.849,5.887,23.056,5.887,23.056,4.415,23.056.491,25.509,18.641,8.83,19.131,5.887,1.472-32.376,0-36.791S708.8,176.758,708.8,176.758Z",
    transform: "translate(-565.284 -150.759)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M850.893,223.236h6.066s4.236,18.641,4.726,20.6,1.472,11.283.981,11.283-10.3-1.962-10.3-.491Z",
    transform: "translate(-690.21 -189.389)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M766.288,323.133H743.067c-2.266-10.424-2.455-20.5,0-30.118h23.221C762.541,302.464,762.307,312.466,766.288,323.133Z",
    transform: "translate(-605.811 -243.124)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M707.938,353.738l6.868,2.943s13.245,1.962,13.245-3.434-13.245-2.453-13.245-2.453l-4.415-1.412Z",
    transform: "translate(-580.122 -286.533)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M678.367,210.435l-5.887,1.472-4.415,26s-1.472,6.868.981,7.358,9.32,4.415,9.32,4.415.981-7.358,2.943-7.358l-4.906-3.924,2.943-17.169Z",
    transform: "translate(-549.079 -179.53)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 32.188,
    height: 0.46,
    transform: "translate(13.852 81.137)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 0.46,
    height: 4.253,
    transform: "translate(22.588 76.999)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 0.46,
    height: 4.253,
    transform: "translate(36.613 76.999)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 32.188,
    height: 0.46,
    transform: "translate(25.117 13.084)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 0.46,
    height: 4.253,
    transform: "translate(48.108 13.429)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 0.46,
    height: 4.253,
    transform: "translate(34.084 13.429)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 32.188,
    height: 0.46,
    transform: "translate(57.535 58.376)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 0.46,
    height: 4.253,
    transform: "translate(80.526 58.721)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 0.46,
    height: 4.253,
    transform: "translate(66.501 58.721)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 32.188,
    height: 0.46,
    transform: "translate(2.816 58.146)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 0.46,
    height: 4.253,
    transform: "translate(25.807 58.491)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 0.46,
    height: 4.253,
    transform: "translate(11.783 58.491)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 32.188,
    height: 0.46,
    transform: "translate(41.441 35.155)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 0.46,
    height: 4.253,
    transform: "translate(50.178 31.017)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 0.46,
    height: 4.253,
    transform: "translate(64.202 31.017)",
    fill: "#f2f2f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.30f36c0e3c72a38763df5c5a818609d7.svg";
export { ForwardRef as ReactComponent };